import enums from '../../controllers/enums'

const tipoPerfilOperador = enums.TipoOperadorRetaguarda

const rotaGeral = [
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/',
    menu: true,
    meta: {
      role: [tipoPerfilOperador.nenhum]
    }
  },
  {
    title: 'Onboarding',
    icon: 'fas fa-user-plus',
    path: '/onboarding/',
    dir: 'views/onboarding/',
    menu: true,
    meta: {
      roles: [tipoPerfilOperador.administrador],
      allRolesRequired: true
    },
    items: [
      {
        path: 'Conta/',
        view: 'Conta',
        title: 'Conta',
        menu: true,
        meta: {
          // role: ['Nenhum']
        },
      },
    ]
  },
  {
    title: 'Cadastros',
    icon: 'fas fa-edit',
    path: '/cadastros/',
    dir: 'views/cadastros/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'correntista',
        view: 'Correntista',
        title: 'Correntistas',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'contas',
        view: 'Conta',
        title: 'Contas',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'cedente',
        view: 'Cedente',
        title: 'Cedente',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'cedente-carteira',
        view: 'CedenteCarteira',
        title: 'Cedentes x Carteiras',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'operador-front-end',
        view: 'OperadorFrontEnd',
        title: 'Operador Frontend',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'operador-retaguarda',
        view: 'OperadorRetaguarda',
        title: 'Operador Retaguarda',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta],
          allRolesRequired: true,
          parameters: ['operadorRetaguardaHabilitado']
        }
      },
      {
        path: 'operador-onboarding-externo',
        view: 'OperadorOnboardingExterno',
        title: 'Operador Onboarding Externo',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'split',
        view: 'Split',
        title: 'Split',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador]
        }
      },
      {
        path: 'tarifario',
        view: 'Tarifario',
        title: 'Tarifário',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'tarifa-recorrente',
        view: 'TarifaRecorrente',
        title: 'Tarifa Recorrente',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'transferenciaprogramada/',
        title: 'Transferência Programada',
        dir: 'TransferenciaProgramada/',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
        },
        items: [
          {
            path: 'geral',
            view: 'RepasseSaldoConta',
            title: 'Geral',
            dir: 'Geral/',
            menu: true,
            meta: {
              roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
            }
          },
          {
            path: 'logs',
            title: 'Logs',
            dir: 'Logs',
            menu: true,
            meta: {
              roles: ['Administrador']
            },
            items: [
              {
                path: 'geral',
                view: 'Geral',
                title: 'Geral',
                dir: '/',
                menu: true,
                meta: {
                  roles: ['Administrador']
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: 'Consultas',
    icon: 'fas fa-search',
    path: '/consultas/',
    dir: 'views/consultas/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'extrato',
        view: 'Extrato',
        title: 'Extrato',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'agendamentos',
        view: 'Agendamentos',
        title: 'Transações Agendadas',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'aprovacoes',
        view: 'Aprovacoes',
        title: 'Aprovações de Transações',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'logtransacionalcartao',
        view: 'LogTransacionalCartao',
        title: 'Log Transacional Cartão',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      }
    ]
  },
  {
    title: 'Processos',
    icon: 'fas fa-tasks',
    path: '/processos/',
    dir: 'views/processos/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'comprovante',
        view: 'Comprovante',
        title: '2ª Via de Comprovantes',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'cnab/',
        title: 'CNAB',
        dir: 'cnab/',
        menu: true,
        meta: {
          // role: ['Nenhum']
        },
        items: [
          {
            path: '400/',
            title: '400',
            dir: '400/',
            menu: true,
            meta: {
              // role: ['Nenhum']
            },
            items: [
              {
                path: 'importacao',
                view: 'Importacao',
                title: 'Importação',
                menu: true,
                meta: {
                  // role: ['Nenhum']
                }
              },
              {
                path: 'exportacao',
                view: 'Exportacao',
                title: 'Exportação',
                menu: true,
                meta: {
                  // role: ['Nenhum']
                }
              },
              {
                path: 'transferenciaCedente',
                view: 'TransferenciaCedente',
                title: 'Transferência de cedente - Aprovados',
                menu: true,
                meta: {
                  // role: ['Nenhum']
                }
              }
            ]
          },
        ]
      }
    ]
  },
  {
    title: 'Boletos',
    icon: 'fas fa-file-invoice-dollar',
    path: '/dda/',
    dir: 'views/dda/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'registroboleto',
        view: 'RegistroBoleto',
        title: 'Registro Boleto',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'consultaboleto',
        view: 'ConsultaBoleto',
        title: 'Consulta Boleto',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'alteracaoboleto',
        view: 'AlteracaoBoleto',
        title: 'Alteração Boletos',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'cancelarboletos',
        view: 'CancelarBoleto',
        title: 'Cancelar Boletos',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'transferenciacedente',
        view: 'TransferenciaCedente',
        title: 'Transferência Cedente',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro, tipoPerfilOperador.consulta]
        }
      },
      {
        title: 'DDA',
        path: 'pagadoreletronico/',
        dir: 'pagadoreletronico/',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
        },
        items: [
          {
            path: 'adesao',
            view: 'Adesao',
            title: 'Adesão',
            menu: true,
            meta: {
              roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
            }
          },
          {
            path: 'consulta',
            view: 'Consulta',
            title: 'Consulta',
            menu: true,
            meta: {
              roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
            }
          }
        ]
      },
      {
        title: 'Protesto de Boleto',
        path: 'ProtestoBoleto/',
        dir: 'protestoBoleto/',
        menu: true,
        meta: {
          roles: ['Administrador']
        },
        items: [
          {
            path: 'consultar',
            view: 'BoletosProtestados',
            title: 'Consulta',
            menu: true,
            meta: {
              roles: ['Administrador']
            }
          },
          {
            path: 'protestar',
            view: 'ProtestarBoleto',
            title: 'Protestar',
            menu: true,
            meta: {
              roles: ['Administrador']
            }
          }
        ]
      }
    ]
  },
  {
    title: 'Consulta Operacional',
    icon: 'fas fa-briefcase',
    path: '/consultaoperacional/',
    dir: 'views/consultaoperacional/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'movporconta',
        view: 'MovPorConta',
        title: 'Movimentações por Conta',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'relatoriosaldo',
        view: 'RelatorioSaldo',
        title: 'Relatório de Saldo',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
        }
      },
      {
        path: 'relatorioboletoregistrado',
        view: 'RelatorioBoletoRegistrado',
        title: 'Relatório de Boletos Registrados',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'relatoriocontas',
        view: 'RelatorioContas',
        title: 'Relatório de Contas',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'relatoriodivergenciascontas',
        view: 'RelatorioDivergenciasContas',
        title: 'Divergências Cadastrais',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'downloadrelatorio',
        view: 'DownloadRelatorio',
        title: 'Download Relatório',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'relatorioTarifaRecorrente',
        view: 'RelatorioTarifaRecorrente',
        title: 'Relatório Tarifa Recorrente',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      }
    ]
  },
  {
    title: 'Histórico',
    icon: 'fas fa-history',
    path: '/historico/',
    dir: 'views/historico/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'encerramentoconta',
        view: 'HistoricoEncerramento',
        title: 'Contas Encerradas',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      // {
      //   path: 'HistoricoSplit',
      //   view: 'HistoricoSplit',
      //   title: 'Split',
      //   menu: true,
      //   meta: {
      //     // role: ['Nenhum']
      //   }
      // },
      {
        path: 'TarifarioHistorico',
        view: 'TarifarioHistorico',
        title: 'Tarifário',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'onboarding/',
        menu: true,
        view: '',
        title: 'Onboarding',
        meta: {
          // role: ['Nenhum']
        },
        items: [
          {
            path: 'Conta/',
            view: 'HistoricoConta',
            title: 'Conta',
            menu: true,
            meta: {
              // role: ['Nenhum']
            },
          },
        ]
      },
    ]
  },
  {
    title: 'Agenda de Recebíveis',
    icon: 'fas fa-calendar',
    path: '/agendaderecebiveis/',
    dir: 'views/agendaderecebiveis/',
    menu: true,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      }
    ],
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'parametrizacaoglobal',
        view: 'ParametrizacaoGlobal',
        title: 'Parametrização Global',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'parametrizacaocedente',
        view: 'ParametrizacaoCedente',
        title: 'Parametrização Cedente',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'agendaconsolidada',
        view: 'AgendaConsolidada',
        title: 'Agenda Consolidada',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'negociacaoduplicatas',
        view: 'NegociacoesDuplicatas',
        title: 'Negociações de Duplicatas',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
    ]
  },
  {
    path: '/agendaderecebiveis/detalhesduplicata/:codigo',
    view: 'DetalhesDuplicata',
    dir: 'views/agendaderecebiveis/',
    title: 'Detalhes da duplicata',
    menu: false,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      },
      { text: 'Agenda Consolidada', href: '/agendaderecebiveis/agendaconsolidada' },
      { text: 'Detalhes da duplicata' }
    ],
    meta: {}
  },
  {
    path: '/agendaderecebiveis/detalhesnegociacao/:id',
    view: 'DetalhesNegociacao',
    dir: 'views/agendaderecebiveis/',
    title: 'Ver detalhes da Negociação',
    menu: false,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      },
      {
        text: 'Negociações de Duplicatas',
        href: '/agendaderecebiveis/negociacaoduplicatas'
      },
      { text: 'Ver detalhes da Negociação' }
    ],
    meta: {}
  },
  {
    path: '/agendaderecebiveis/aceitarproposta/:id',
    view: 'AceitarProposta',
    dir: 'views/agendaderecebiveis/',
    title: 'Aceitar proposta',
    menu: false,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      },
      {
        text: 'Negociações de Duplicatas',
        href: '/agendaderecebiveis/negociacaoduplicatas'
      },
      { text: 'Aceitar proposta' }
    ],
    meta: {}
  },
  {
    path: '/agendaderecebiveis/recusarproposta/:id',
    view: 'RecusarProposta',
    dir: 'views/agendaderecebiveis/',
    title: 'Recusar proposta',
    menu: false,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      },
      {
        text: 'Negociações de Duplicatas',
        href: '/agendaderecebiveis/negociacaoduplicatas'
      },
      { text: 'Recusar proposta' }
    ],
    meta: {}
  },
  {
    path: '/agendaderecebiveis/cancelarnegociacao/:id',
    view: 'CancelarNegociacao',
    dir: 'views/agendaderecebiveis/',
    title: 'Cancelar negociação',
    menu: false,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      },
      {
        text: 'Negociações de Duplicatas',
        href: '/agendaderecebiveis/negociacaoduplicatas'
      },
      { text: 'Cancelar negociação' }
    ],
    meta: {}
  },
  {
    path: '/agendaderecebiveis/solicitarnegociacao',
    view: 'SolicitarNegociacao',
    dir: 'views/agendaderecebiveis/',
    title: 'Solicitar negociação',
    menu: false,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      },
      { text: 'Agenda Consolidada', href: '/agendaderecebiveis/agendaconsolidada' },
      { text: 'Solicitar negociação' }
    ],
    meta: {}
  },
  {
    path: '/agendaderecebiveis/informarliquidacao/:idNegociacao/:codigoDuplicata',
    view: 'InformarLiquidacao',
    dir: 'views/agendaderecebiveis/',
    title: 'Informar liquidação',
    menu: false,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      },
      {
        text: 'Negociações de Duplicatas',
        href: '/agendaderecebiveis/negociacaoduplicatas'
      },
      { text: 'Informar liquidação' }
    ],
    meta: {}
  },
  {
    path: '/agendaderecebiveis/confirmarpagamento/:idNegociacao',
    view: 'ConfirmarPagamento',
    dir: 'views/agendaderecebiveis/',
    title: 'Confirmar pagamento',
    menu: false,
    breadcrumbs: [
      {
        text: 'Agenda de Recebíveis',
        icon: 'fas fa-calendar',
        href: '/agendaderecebiveis/agendaconsolidada'
      },
      {
        text: 'Negociações de Duplicatas',
        href: '/agendaderecebiveis/negociacaoduplicatas'
      },
      { text: 'Confirmar pagamento' }
    ],
    meta: {}
  },
  {
    path: '/',
    view: 'Login',
    title: 'Login',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/lembrar',
    view: 'Lembrar',
    title: 'Lembrar',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/recuperar',
    view: 'Alterar',
    title: 'Alterar',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/authcompany',
    view: 'AuthCompany',
    title: 'Parceiro',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/mfa/solicitarPermissao',
    view: 'SolicitacaoMfa',
    title: 'Solicitacao MFA',
    dir: 'views/mfa/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/mfa/introducao',
    view: 'IntroducaoMfa',
    title: 'Informações MFA',
    dir: 'views/mfa/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/mfa/validardispositivo',
    view: 'ValidarDispositivoJornada',
    title: 'Validar MFA',
    dir: 'views/mfa/',
    props: true,
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/mfa/registrartoken',
    view: 'RegistarTokenDispositivo',
    title: 'Registar Token',
    dir: 'views/mfa/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/verificar',
    view: 'Verificar',
    title: 'verificar',
    dir: 'views/',
    menu: false,
    params: true,
    meta: {
      anonymousAuth: true
    }
  }
]


function filterRoutes(routes, onboardingContaHabilitado, agendaRecebiveisHabilitado) {
  return routes
    .filter(route => {
      if (route.path.includes('onboarding')) {
        return onboardingContaHabilitado;
      }

      if (!agendaRecebiveisHabilitado && route.path.includes('agendaderecebiveis')) {
        return false;
      }

      if (route.items) {
        route.items = filterRoutes(route.items, onboardingContaHabilitado, agendaRecebiveisHabilitado);
      }
      return true;
    });
}

export default function getFilteredRoutes(habilitado, agendaRecebiveisHabilitado) {
  return filterRoutes(rotaGeral, habilitado, agendaRecebiveisHabilitado);
}
